import React from 'react';
import { ProductOrderingEditTemplate } from 'themes/application/product-ordering/pages';
import { observer } from 'mobx-react';
import { ProductOrderingEditViewStore } from 'application/product-ordering/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ProductOrderingEditViewStore(rootStore), 'productOrderingEditViewStore')
@observer
class ProductOrderingEdit extends React.Component {
    render() {
        return <ProductOrderingEditTemplate {...this.props} />
    }
}

export default ProductOrderingEdit;